import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'locale-select',
  templateUrl: './locale-select.component.html',
  styleUrls: [
    './locale-select.component.scss'
  ]
})
export class LocaleSelectComponent {
  public translate: TranslateService;

  public constructor(translate: TranslateService) {
    this.translate = translate;
  }
}
